import { httpGet } from 'src/utils/http';
import { HelpCardResponseType } from 'src/models/helpCard';

export const apiGetHelpCard = (): Promise<HelpCardResponseType> => httpGet('/helpcard/gethelpcard');
